import api from '../services/api'

export default {
  state: {
    docs: null,
  },
  actions: {
    loadDocs ({ commit, state }) {
      if (state.docs) {
        return Promise.resolve()
      }
      return api.loadDocs().then((response) => {
        commit('setDocs', response.data)
      })
    },
    loadDocsToken ({ commit, state }) {
      if (state.docs) {
        return Promise.resolve()
      }
      return api.loadDocsToken().then((response) => {
        commit('setDocs', response.data)
      })
    },
  },
  mutations: {
    setDocs (state, payload) {
      state.docs = payload
    },
  },
  getters: {
    docs (state) {
      return state.docs || []
    },
    endpoint (state) {
      return (path) => {
        return state.docs ? state.docs.find((i) => i.path === path) : null
      }
    },
  },
  namespaced: true,
}
